/**
 * API网关工具接口
 */
import * as utilType from './type';

/**
 * 确保参数安全。因为API网关的特殊性，很操蛋
 * 1. 参数不能少
 * 2. 参数不能多
 * @param {object} params 参数
 * @param {object} definedParams 接口定义的参数
 */
export function ensureParams(params, definedParams) {
  params = { ...definedParams, ...params };
  const paramsKeys = Object.keys(params);

  paramsKeys.forEach((key) => {
    if (!(key in definedParams)) {
      delete params[key];
    }

    if (params[key] === undefined || params[key] === null) {
      params[key] = definedParams[key] || '';
    }

    // 查询参数不知如何表示空数组
    if (utilType.isArray(params[key]) && params[key].length === 0) {
      params[key] = '';
    }
  });

  return params;
}
